import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Moment from 'moment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import 'moment/locale/pt-br';
import AddIcon from '@mui/icons-material/Add';

export const AvisosPage = (props) => {
  const { listarAvisos, deletarAviso } = useQuery();
  const [avisos, setAvisos] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const deletar = async (id) => {
    setLoading(true);

    const result = await deletarAviso(id);

    if (result && result.data) {
      console.log(result.data.data);
      listar();
    }

    setLoading(false);
  };

  const listar = async () => {
    setLoading(true);

    const result = await listarAvisos();

    if (result && result.data) {
      setAvisos(result.data.data);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    listar();
  }, []);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Avisos do Sistema
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12} display="flex" justifyContent="flex-end">
          <Button
            onClick={() => {
              navigate(`/dashboard/criar-aviso`);
            }}
            variant="contained"
            startIcon={<AddIcon />}
          >
            Novo Aviso
          </Button>
        </Grid>
        <Grid item sm={12} width="100%">
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div
              style={{
                width: '100%',
                overflowX: 'scroll',
                overflowY: 'hidden',
              }}
            >
              <table className="app_table">
                <thead
                  style={{
                    color: theme.palette.primary.main,
                    borderTop: `8px solid ${theme.palette.primary.light}`,
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        width: '60%',
                      }}
                    >
                      Aviso
                    </th>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      Data
                    </th>
                    <th
                      style={{
                        width: '10%',
                      }}
                    ></th>
                    <th
                      style={{
                        width: '10%',
                      }}
                    ></th>
                  </tr>
                </thead>

                <tbody>
                  {avisos &&
                    avisos.length > 0 &&
                    avisos.map((aviso, index) => (
                      <tr>
                        <td style={{ textAlign: 'left' }}>{index + 1}</td>
                        <td style={{ textAlign: 'left' }}>{aviso.texto}</td>
                        <td style={{ textAlign: 'left' }}>
                          {Moment(aviso.created_at).format('DD/MM/YYYY hh:mm')}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              navigate(
                                `/dashboard/criar-aviso?aviso_id=${aviso.id}`,
                              );
                            }}
                            style={{ width: '100%', marginTop: 10 }}
                          >
                            Editar
                          </Button>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => deletar(aviso.id)}
                            style={{ width: '100%', marginTop: 10 }}
                          >
                            Excluir
                          </Button>
                        </td>
                      </tr>
                    ))}
                  {!loading && avisos && avisos.length == 0 ? (
                    <tr>
                      <td colSpan={5} align="center">
                        Nenhum Aviso encontrado.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
